var $ = require('jQuery');
var MarkdownEditor = require('../../lib/markdown-editor.js');
var MergeFields = require('../../lib/merge-fields.js');
var Uploader = require('uploader');

module.exports = function() {

    // Setup the Uploader, if included on the page.
    if ($("#uploader").length > 0) {
        var options = uploaderOptions.clarify();
        new Uploader(options);
    }

    // Bind Multi Upload 'Delete' button action.
    $('.images').on('click', '.upload-multi .upload-actions .delete', function () {

        var container = $(this).closest('.upload-multi');
        var fileId = container.find('input.upload-id').val();
        var deletedOrder = container.find('.sort-order').text();

        container.remove();

        $('.images .upload-multi').each(function() {
            var order = $(this).find('.sort-order').text();
            var newOrder = order - 1;
            if (order > deletedOrder) {
                $(this).find('.sort-order').text(newOrder);
            }
        });

        $.ajax({
            'type': 'DELETE',
            'url': imageDeleteUrl.replace(new RegExp('0$'), fileId)
        });
    });

    // Decode Seasonal Parents
    var seasonSelector = $('#seasonId');
    var decodedSeasonalParents = seasonalParents.clarify();

    // Refresh Parents list.
    var refreshParents = function () {
        var parents = decodedSeasonalParents[seasonSelector.val()];
        var parentSelect = $("#parent");
        var parentVal = parentSelect.val();

        parentSelect.empty();
        parentSelect.append('<option value="">-</option>');

        $.each(parents, function(i) {
            parentSelect.append($('<option>', parents[i]));
        });

        parentSelect.val(parentVal);
    };

    // Bind to on change for season selector.
    seasonSelector.on('change', function() {
        refreshParents();
    });

    // Finally, trigger on load.
    refreshParents();

    // Category Divisions
    var divisions = $('#divisions');
    var reassign = $('#reassign-divisions');
    var divisionsCount = divisions.val();
    var reassignChecked = false;

    // Toggle reassign on divisions keyup
    divisions.on('keyup', function () {
        if (parseInt(divisions.val()) < parseInt(divisionsCount)) {
            reassign.prop('checked', true);
            reassign.prop('disabled', true);
        } else {
            reassign.prop('checked', reassignChecked);
            reassign.prop('disabled', false);
        }
    });

    // Remember manual reassign selection
    reassign.on('change', function () {
        reassignChecked = reassign.prop('checked');
    });

    // Attachment types overrides
    var overrides = $('input[id^="score-set-"]');

    var toggleOverride = function () {
        var checkbox = $(this);
        var container = checkbox.parents().eq(2);

        if (checkbox.is(':checked')) {
            container.find('.multiselect').removeClass('hidden');
            container.find('input[name^="attachmentTypes"]').attr('disabled', false);
        } else {
            container.find('.multiselect').addClass('hidden');
            container.find('input[name^="attachmentTypes"]').attr('disabled', true);
        }
    };

    overrides.change(toggleOverride);
    overrides.each(toggleOverride);

    // Toggle packing slip instructions
    var packingSlipCheckbox = $('input[id="packingSlip"]');
    var packingSlipInstructions = $('.packing-slip-instructions');
    var markdownEditor = new MarkdownEditor();

    var togglePackingSlipInstructions = function () {
        var checkbox = $(this);

        if (checkbox.is(':checked')) {
            packingSlipInstructions.removeClass('hidden');
            markdownEditor.setup('.packing-slip-instructions textarea[class~="mde"]:visible');

        } else {
            packingSlipInstructions.addClass('hidden');
        }
    };

    packingSlipCheckbox.change(togglePackingSlipInstructions);
    togglePackingSlipInstructions.call(packingSlipCheckbox);

    // Merge fields
    var mergeFields = new MergeFields();
    mergeFields.setup('merge-fields', 'textarea[id="packingSlipInstructions"]');
};
